import { useAutoAnimate } from '@formkit/auto-animate/react';
import { Nothing } from 'components/Nothing';
import { TitleRow } from 'components/TitleRow';
import { FC, useState } from 'react';
import { EmployedItem } from 'ui/EmployedItem';
import styles from './EmployedsList.module.scss';
import { Employed } from 'redux/Api/employedsApi/type';

export interface workerAppTypes {
  app_status: number;
  avatar?: string | null;
  verified: number;
  moderated: number;
  app_exit: number;
  fns_status: number;
  date_create: string | null;
}

export interface EmpoyedTypes {
  created_at: string;
  fns_status: number;
  id: number;
  inn: string;
  last_info_update: string | null;
  name: string;
  nationality: string;
  patronymic: string;
  phone: string;
  surname: string;
  name_invite?: string;
  worker_app: workerAppTypes;
  limit?: number | null;
  limit_updated_at?: string | null;
  limit_updated_by_user?: string | null;
  monthly_payment?: number;
}

interface EmployedsListTypes {
  data: Employed[];
  dataTitle: string[];
  intersectionComponent: JSX.Element | null;
  hideTitleRow?: boolean;
  setIsCreatedModalOpen: (value: boolean) => void;
}

export const EmployedsList: FC<EmployedsListTypes> = ({
  data,
  intersectionComponent,
  hideTitleRow,
  dataTitle,
  setIsCreatedModalOpen,
}) => {
  const [parent] = useAutoAnimate({ duration: 200 });
  const role = localStorage.getItem('role') || 'WorkSupport';

  const [openCategoryId, setOpenCategoryId] = useState<number | null>(null);

  const handleCategoryToggle = (employedId: number) => {
    setOpenCategoryId((prev) => (prev === employedId ? null : employedId));
  };

  return (
    <div ref={parent} className={styles.root}>
      {!hideTitleRow && (
        <TitleRow
          data={dataTitle}
          title={role === 'director' ? 'employedsCustomer' : 'employeds'}
        />
      )}
      {data?.length ? (
        <div className={styles.window}>
          {data.map((item: Employed) => (
            <EmployedItem
              key={item.id}
              role={role}
              employed={item}
              setIsCreatedModalOpen={setIsCreatedModalOpen}
              isCategoryOpen={openCategoryId === item.id}
              onCategoryToggle={() => handleCategoryToggle(item.id)}
            />
          ))}
          {intersectionComponent}
        </div>
      ) : (
        <Nothing style={{ height: '640px' }} title='Ничего не найдено' />
      )}
    </div>
  );
};
